/**
 * The words that name this format or its SDK: the pack's `vocabulary`, and the words the core's
 * format-names test forbids in any core file. A module rather than JSON, because the SDK's build
 * bundles no JSON.
 */
const VOCABULARY: readonly string[] = [
  'docx-sfdt',
  'docx',
  'sfdt',
  'syncfusion',
  'ej2',
  'documenteditor',
  'content control',
  'contentcontrol'
];

export default VOCABULARY;
